import { List } from 'entities/task/model/types/tasksInformationSchema';

export const filterList = (list: List, filteredTasksId: string[]): List => {
    const filteredList: List = {
        no_term: [],
        completed: [],
    };
    const idSet = new Set(filteredTasksId);

    for (const key in list) {
        if (Object.prototype.hasOwnProperty.call(list, key)) {
            const filteredIds = list[key].filter((id) => idSet.has(id));
            if (filteredIds.length > 0) {
                filteredList[key] = filteredIds;
            }
        }
    }

    return filteredList;
};
